<template>
	<div class="animated fadeIn">
		<b-card>
			<b-card-header>
				<i class="icon-menu mr-1"></i>QRCode列印
				<div class="card-header-actions">
					<b-link @click="generateQRCodes()" v-if="!cannotEdit"><i class="fa fa-print"></i> 列印</b-link>&nbsp;
				</div>
			</b-card-header>
			<b-card-body>
				<div class="row">
					<div class="col-12 d-flex justify-content-center">
						<div style="width: 95%;" class="mx-auto">
							<b-button style="margin: 0 3px 0 0; color: white;" size="sm" variant="success" @click="toggleAllCheckboxes(true)">選擇全部</b-button>
							<b-button style="margin: 0 3px 0 3px; color: white;" size="sm" variant="danger" @click="toggleAllCheckboxes(false)">清除全部</b-button>
						</div>
					</div>
					<div class="col-12">
						<v-server-table :columns="columns" :data="devices" :options="options" :theme="theme" ref="dataTable" id="dataTable">
							<!--<input slot="check" slot-scope="props" type="checkbox" :checked="props.row.check" @change="selectRow(props.row)">-->
							<input :id="'Checkbox'+props.row.sn" slot="check" slot-scope="props" type="checkbox" :checked="props.row.check" @change="selectRow(props.row)">
							<a slot="end_user_id" slot-scope="props">{{props.row.EndUser ? props.row.EndUser.name : '未連結'}}</a>
							<a slot="device_activated" slot-scope="props" class="d-inline-block text-center w-100"><span :id="'PHolder'+props.row.sn"><i class="fa fa-question-circle"></i></span></a>
							<a slot="company_id" slot-scope="props">{{props.row.Company?props.row.Company.name:'N/A'}}</a>
							<a slot="brand_id" slot-scope="props">{{props.row.ChargerBrand?props.row.ChargerBrand.name:'N/A'}}</a>
							<!--<a slot="charge_first" class="text-center" slot-scope="props">{{props.row.charge_first?`Y($${props.row.charge_value})`:''}}</a>-->
							<a slot="billing_method" class="text-center" slot-scope="props">{{props.row.billing_method}}</a>
						</v-server-table>
					</div>
				</div>
			</b-card-body>
		</b-card>

		<b-modal title="裝置QR Code" v-model="showQrCode" ok-title="確定" cancel-title="取消">
			<div class="w-100 text-center">
				<img id="qrcode-canvas">
				<p class="text-muted">存取裝置的QR Code</p>
				<p class="text-primary"><a :href="device_uri" target="_blank">URI</a></p>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import io from 'socket.io-client'
import _ from 'lodash'
import moment from 'moment-timezone'
import QRious from 'qrious'
import jsPDF from "jspdf";

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;
let $socket = null;

Vue.use(ServerTable)

export default {
	name: 'qrcode_print',
	notifications,
	components: {
		ServerTable,
		Event,
		Multiselect,
        vSelect,
    },
	data(){
		let app = this;
		let cannotEdit = app.$state.$get('ccff') === 'N/A' ? false : true;
		return {
			//selectAll: false, // 全選checkbox的勾選狀態
			selectedRows: [], // 每一行checkbox的勾選狀態
			qr_images: [], // 存放 QRCode Base64 圖片
			text_images: [], // 存放 裝置名稱 Base64 
			final_images: [],
			devices: [],
			cannotEdit,
			device_uri: '',
			showQrCode: false,
			showQrCodes: false,
			showLogList: false,
			selected_row: null,
			editRowId: null,
			columns: ['check', 'name', 'company_id', 'sn', 'end_user_id', 'brand_id', 'geo_location', 'billing_method', 'device_activated', 'remarks'],
			data: [],
			options: {
				debounce: 86400000, // 停止預設的即時搜尋
				headings: {
					check: '',
					name:  '名稱',
					company_id: '公司',
					sn:    '序號',
					end_user_id: '擁有者',
					brand_id: '廠牌',
					device_activated: '作動？',
					geo_location: '地理位置',
					billing_method: '計費方式',
					remarks: '備註'
				},
				orderBy: {
					column: 'created',
					ascending: false
				},
				sortable: ['name', 'company_id', 'sn', 'end_user_id', 'brand_id', 'geo_location'],
				filterable: ['name', 'sn', 'end_user_id', 'geo_location'],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					let action = `${admin_root}/get_list/Device`;
					let params = {
					    keyset: 'mqtt'
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = ''+data[col];
					}

					return fetch(action, {
						method: 'POST',
						headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						//console.info('logdata result: ', result);
						app.$nextTick(() => {
							//app.selectAll = false;
							app.devices = result.data;
							// 假設 result.data 是陣列，遍歷它並為每行添加 `check` 欄位
							console.info('jsonp request');
							app.devices = result.data.map(device => ({
								...device,
								check: false  // 初始化每行的 check 欄位為 false（未選中）
							}));
							app.set_mqtt_listen_list(result.data);
						});
						return {
						data: result.data || [],
						count: result.count || 0
						};
					}).catch(error => {
						app.$nextTick(() => {
							app.set_mqtt_listen_list([]);
						});
						return {
						data: [],
						count: 0
						};
					});
				}//eo requestFunction
			},
			useVuex: false,
	        theme: 'bootstrap4',
	        template: 'default'
		};//eo return
	},//eo data
	
	mounted(){
		let app = this;

		// Search field 按下Enter後開始搜尋
		this.$nextTick(() => {
			let searchInput = document.querySelector('.VueTables__search-field input');
			if (searchInput) {
				// 取消 Vue Tables 內部的即時搜尋
				/*searchInput.addEventListener('input', (event) => {
					console.info('searchInput event:', event);
				}, true); // 捕獲模式，確保先執行*/

				// 監聽 Enter 鍵，才真正搜尋
				searchInput.addEventListener('keyup', (event) => {
					//console.info('keyup: ', event.key);
					//this.showSuccess({message:`key: ${event.key}`});
					if (event.key === "Enter" || event.key === "Go" || event.key === "Search") {
						this.$refs.dataTable.setFilter(searchInput.value);

						//強制清除 Vue Tables 內部的 debounce 計時器
						//this.$refs.dataTable.query = searchInput.value; // 直接覆寫內部值，避免 24 小時後觸發
					}
				});

				// 監聽 "失去焦點" (按 "下一步" 後，強制搜尋)
				searchInput.addEventListener('blur', () => {
					//console.info('blur event: 搜尋觸發');
					//this.showSuccess({message:'blur event: 搜尋觸發'});
					this.$refs.dataTable.setFilter(searchInput.value);
				});
			}
		});

		$socket = io(config.socket_entry, {transports: ['polling']});
		$socket.on('connect', () => {
			console.info('socket connected...');
		});

		$socket.on('mqtt_connected', (data) => {
			if(data.message.indexOf('&') !== -1){
				let parsed = config.mqtt_msg_parser(data.message);
				if(parsed && parsed.deviceid){
					jQuery('#PHolder'+parsed.deviceid).html('<span class="text-success"><i class=" fa fa-check"></i></span>')
				} else {
					jQuery('#PHolder'+parsed.deviceid).html('<span class="text-danger"><i class=" fa fa-times"></i></span>')
				}
			}
		});
	},
	
	beforeDestroy() {
		if ($socket) {
			$socket.disconnect();
			$socket = null;
		}
	},

	methods: {
		// 當全選checkbox改變時，切換所有行的checkbox
		toggleAllCheckboxes(selectAll) {
			//console.info('this.selectAll:', this.selectAll);
			this.$nextTick(() => {
				this.devices.forEach((device, index) => {
					let checkbox = document.getElementById('Checkbox' + device.sn); // 獲取 checkbox 元素
					//this.$set(this.devices, index, { ...this.devices[index], check: selectAll });
					if(device.check != selectAll) {
						checkbox.click(); // 觸發 click 事件
					}
				});
			});
		},
		selectRow(row) {
			row.check = !row.check;
			//console.info(`[selectRow] ${row.name}: ${row.check}`);
			// 強制同步回 `this.devices`
			let index = this.devices.findIndex(device => device.id === row.id); // 根據唯一 ID 找回原始數據
			if (index !== -1) {
				this.$set(this.devices, index, { ...this.devices[index], check: row.check });
			}
		},
		get_device_uri(sn){
			let uuid = encodeURIComponent(config.encrypt(sn, config.ffkey, config.ffiv));
			return `${config.frontend}?uuid=${uuid}`;
		},
		generateQRCodes() {
			this.qr_images = []; // 清空舊的 QRCode
			this.text_images = []; // 清空舊的 裝置名稱
			this.final_images = []; // 清空舊的 裝置名稱

			const checked_number = this.devices.filter(item => item.check).length;
			this.devices.forEach((item, index) => {
				if(item.check) {
					//console.info('selected:', item.name);
					//checked_number++;
					// 使用 QRious 生成 QR code，並設置 size 為 160（QR code 區域）
					const qrCanvas = document.createElement("canvas");
					qrCanvas.width = 320;
					qrCanvas.height = 320;

					// <<< 新增這段：清成白底
					const qrCtx = qrCanvas.getContext("2d");
					qrCtx.fillStyle = "white";
					qrCtx.fillRect(0, 0, qrCanvas.width, qrCanvas.height);

					let msg = this.get_device_uri(item.sn);
					new QRious({
						element: qrCanvas,
						value: msg, // device_uri 當作 QRCode 內容
						size: 320,
					});

					const text_canvas = document.createElement("canvas"); // 動態建立 canvas
					const scaleFactor = 1; // 解析度放大 2 倍
					text_canvas.width = 320 * scaleFactor; // 設定 text_canvas 寬度
					text_canvas.height = 40 * scaleFactor; // 設定 text_canvas 高度

					// 獲取 text_canvas 的 2d context，並添加中文文字
					const ctx = text_canvas.getContext("2d");

					// 這一行超重要，讓畫布的內容也放大 scaleFactor 倍，不會糊掉
					//ctx.scale(scaleFactor, scaleFactor);

					// 設置背景色為白色，確保背景不是黑色
					ctx.fillStyle = "white";  // 背景顏色設為白色
					ctx.fillRect(0, 0, text_canvas.width, text_canvas.height);  // 填充畫布

					// 設置最大字體大小
					let fontSize = 28;
					ctx.font = `${fontSize}px Noto Sans TC, Microsoft JhengHei, sans-serif`;
					ctx.fillStyle = "black";  // 設置字體顏色

					// 計算文字的寬度
					const text = item.name;
					let textWidth = ctx.measureText(text).width;
					
					// 如果文字太長，動態縮小字體
					while (textWidth > text_canvas.width - 20 && fontSize > 10) {  // 最小字體大小 10px
						fontSize -= 2;  // 減小字體
						ctx.font = `${fontSize}px Noto Sans TC, Microsoft JhengHei, sans-serif`;
						textWidth = ctx.measureText(text).width;
					}

					let textHeight = fontSize;
					// 計算文字的 x 坐標，讓文字置中
					const x = (text_canvas.width - textWidth) / 2;
					// 計算文字的 y 坐標，讓文字置中
					const y = (text_canvas.height + textHeight) / 2 - 8;

					ctx.fillText(text, x, y); // 根據需要調整文字的 x y 坐標
					//console.info(`[${index}] ${text}(${x},${y})`);

					//Test
					// 1. 建立最終合成用的 canvas
					const finalCanvas = document.createElement("canvas");
					const qrWidth = qrCanvas.width;
					const qrHeight = qrCanvas.height;
					const txtWidth = text_canvas.width;
					const txtHeight = text_canvas.height;

					// 以文字寬度為準（通常比 QRCode 寬一點）
					// 也可以根據需要統一大小
					finalCanvas.width = qrWidth;
					finalCanvas.height = qrHeight + txtHeight;

					const finalCtx = finalCanvas.getContext("2d");
					finalCtx.fillStyle = "white";
					finalCtx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

					// 3. 把 QRCode 畫上去 (置中)
					const qrX = (finalCanvas.width - qrWidth) / 2;
					finalCtx.drawImage(qrCanvas, qrX, 0, qrWidth, qrHeight);

					// 4. 把 文字 canvas 畫上去 (置中在下方)
					const textX = (finalCanvas.width - txtWidth) / 2;
					const textY = qrHeight;
					finalCtx.drawImage(text_canvas, textX, textY, txtWidth, txtHeight);

					//TODO: 轉PNG會造成圖片亂碼，且轉PDF後雖然在網頁上打得開，但是實際上PDF檔案是有問題的，PDF reader是無法開啟的
					// 5. 匯出成 JPEG (dataURL)
					const finalImage = finalCanvas.toDataURL("image/jpeg", 1.0);
					this.final_images.push(finalImage);

					if (this.final_images.length === checked_number) {
						//console.log("所有 QRCode 生成完畢");
						this.downloadPDF(); // 生成完畢後下載 PDF
					}
					
					/*
					// 6. (選擇) 下載圖片
					const link = document.createElement("a");
					link.href = finalImage;
					link.download = "QRCode_with_Text.png";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					*/
				}
			});
		},
		downloadPDF(){
			if (this.final_images.length === 0) {
				//console.info("請先生成 QRCode！");
				return;
			}

			const pdf = new jsPDF("p", "mm", "a4"); // A4大小: 210x297mm
			const pageWidth = 210;
			const pageHeight = 297;
			const final_imgWidth = 63; // 圖片大小 (mm)
			const final_imgHeight = 63 + 8;
			const boxPadding = 2; // 外框內留白
			const boxWidth = final_imgWidth + 2 * boxPadding;
			const boxHeight = final_imgHeight + 1 * boxPadding;
			const cols = 3; // 每行放 3 張
			const rows = 4; // 每頁 4 行
			const marginX = (pageWidth - cols * boxWidth) / 2; // 水平居中
			const marginY = (pageHeight - rows * boxHeight) / 2; // 水平居中

			pdf.setDisplayMode(3); // 3 表示高解析度模式

			this.final_images.forEach((src, index) => {
				const col = index % cols;
				const row = Math.floor((index % (cols * rows)) / cols);
				const x = marginX + col * boxWidth;
				const y = marginY + row * boxHeight;

				if (index > 0 && index % (cols * rows) === 0) {
					pdf.addPage(); // 超過 12 張換頁
				}

				// 插入圖片
				pdf.addImage(src, "JPEG", x + boxPadding, y + boxPadding, final_imgWidth, final_imgHeight);

				// 畫虛線外框
				pdf.setDrawColor(0);
				pdf.setLineWidth(0.1);
				pdf.setLineDash([0.5, 1], 0);
				pdf.rect(x, y, boxWidth, boxHeight);

				//console.info(`[${index}] img(${x + boxPadding},${y + boxPadding},${qr_imgWidth},${qr_imgWidth})`);
				//console.info(`[${index}] text(${x + boxPadding},${y + boxPadding + qr_imgHeight},${text_imgWidth},${text_imgHeight})`);
				
				//console.log(`[${index}] qr_images: ${src}`);
				//console.log(`[${index}] text_images: ${this.text_images[index]}`);
			});

			// **方案 1: 直接開啟 PDF**
			const pdfUrl = pdf.output("bloburl"); // 生成 PDF 的 URL
			window.open(pdfUrl, "_blank"); // 在新視窗開啟 PDF

			// **方案 2: 直接下載 PDF**
			//pdf.save("inno9_qrcodes.pdf");

			// 釋放內存
			this.qr_images = [];
			this.text_images = [];
			this.final_images = [];
		},
		set_mqtt_listen_list(datas){
			let device_ids = [];
			datas.forEach((data, idx) => {
				device_ids.push(data.sn);
			});
			//console.info('device_ids:', device_ids);
			$socket.emit('mqtt_socket', {
				type: 'mqtt-listen-list',
				token: this.$state.$get('adminuser').token,
				device_ids: device_ids
			});
		},
	},//eo methods
};
</script>
<style lang="scss">
.card-body{padding:0;}
.add-btn{}
.help-text{margin-top: 0.5rem; margin-left: 0.8rem;}
.multiselect__input{width:100%;border:none;}
#qrcode-canvas{
	display:inline-block;
	margin: auto;
}
#dataTable {
	width: 95%;
	margin: 0 auto;
	margin-top: 0.5rem;
	font-size: 0.75rem;

	.VuePagination {
	  text-align: center;
	  justify-content: center;
	}

	.vue-title {
	  text-align: center ;
	  margin-bottom: 10px;
	}

	.VueTables__search-field {
	  display: flex;
	}
	.VueTables__search-field input {
	  margin-left: 0.25rem;
	}

	.VueTables__limit-field {
	  display: flex;
	}

	.VueTables__limit-field select {
	  margin-left: 0.25rem !important;
	}

	.VueTables__table th {
	  text-align: center;
	}

	.VueTables__child-row-toggler {
	  width: 16px;
	  height: 16px;
	  line-height: 16px;
	  display: block;
	  margin: auto;
	  text-align: center;
	}

	.VueTables__child-row-toggler--closed::before {
	  content: "+";
	}

	.VueTables__child-row-toggler--open::before {
	  content: "-";
	}

	.VueTables__sortable {
		padding: 0.25rem;
	}
}
.modal .modal-xl {
	max-width: 90% !important;
    width: 90% !important;
}
.custom-table th,
.custom-table td {
	text-align: center;
	vertical-align: middle;
	padding: 1px;
}
.custom-table-for-week th,
.custom-table-for-week td {
	text-align: center;
	vertical-align: middle;
	padding: 1px;
}
.custom-container {
	width: 50% !important;
}
.device-list-clickable-text {
	cursor: pointer;
	transition: background-color 0.3s, color 0.3s;
	color: black !important;
	text-decoration: none !important;
}
.device-list-clickable-text.clicked {
	background-color: #007bff;
	color: white !important;
}
.top-up-btn-sm{
	height: 3rem;
	max-width: 98%;
	min-width: 98%;
	margin: 0.5px 0px;
}
.custom-padding {
	padding: 0px;
}

</style>
